import React, { useEffect } from "react";
import AOS from "aos";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import "aos/dist/aos.css";
import "./collection.css";

// Define an array of card details/text for the three slots

export default function Collections({ data = [], latestYear }) {
	const cardDetails = [
		{
			text: "Step Into Style",
			defaultRoute: `/prom/${latestYear}`,
			alt: "Featured Style 1",
		},
		{
			text: "Shine With Grace",
			defaultRoute: `/prom/${latestYear}`,
			alt: "Featured Style 2",
		},
		{
			text: "Wear Your Bold",
			defaultRoute: `/prom/${latestYear}`,
			alt: "Featured Style 3",
		},
	];
	const filteredData = Array.isArray(data)
		? data
				// 1. FILTER: Keep only items where viewInfront is true
				.filter((item) => item.viewInfront === true)
				// 2. RANDOMIZE: Shuffle the filtered results
				.sort(() => 0.5 - Math.random())
				// 3. LIMIT: Take only the first 3 (or fewer if fewer are featured)
				.slice(0, 3)
		: [];

	useEffect(() => {
		AOS.init({
			duration: 500,
			easing: "ease-in-out",
			once: true,
		});
	}, []);

	// 🛑 IMPORTANT SAFETY CHECK: If no featured data, return null or a message.
	// If you expect at least 3 cards to always show (e.g., using placeholders),
	// you would modify the rendering below instead of returning early.
	if (filteredData.length === 0) {
		return (
			<div className="mb-20 px-4 md:px-10 text-center font-lora">
				<h3 className="font-semibold text-3xl md:text-5xl mb-20">
					Discover Your Signature Style
				</h3>
				<p className="text-gray-500">
					No featured collections available at the moment.
				</p>
			</div>
		);
	}
	console.log("lastesd Years : ...", latestYear);

	// Combine the featured product data with the static card details
	const cardsToRender = cardDetails.map((detail, index) => ({
		...detail,
		// Use the featured product data if available, otherwise data is undefined
		product: filteredData[index],
	}));

	return (
		<div className="mb-20 px-4 md:px-10">
			{/* Section Title */}
			<div className="text-center font-lora font-semibold text-3xl md:text-5xl mb-20">
				<h3>Discover Your Signature Style</h3>
			</div>

			{/* Grid Layout */}
			<div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5 py-10 md:px-10 px-0 font-lora">
				{cardsToRender.map((card, index) => {
					// Default image/route if product is not found (filteredData < 3)
					const imageSource = card.product?.images?.[0]
						? `https://admin.monsinidress.com/${card.product.images[0]}`
						: "URL_TO_DEFAULT_PLACEHOLDER_IMAGE"; // 👈 Add a placeholder image URL here

					// Use the product's actual year route if available, otherwise use default
					const linkRoute = card.product
						? `/prom/${card.product.year}` // assuming you want to link to the specific product/style
						: card.defaultRoute; // /prom/2026 if product is missing

					const imageAlt = card.product ? card.product.style : card.alt;

					return (
						<div
							key={index}
							className="w-full md:h-[700px] h-[500px] relative overflow-hidden group">
							<img
								src={imageSource}
								alt={imageAlt}
								// Adjust object position for visual variety based on card index
								className={`w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 ${
									index === 0
										? "object-left-top"
										: index === 1
										? "object-center"
										: "object-right-top"
								}`}
							/>
							<div className="absolute inset-0 flex items-end justify-end pb-8 pr-8">
								<Link to={linkRoute}>
									<span className="flex justify-center items-center text-white text-[20px] font-bold uppercase tracking-wider p-3 bg-[#1f4c94] bg-opacity-75 rounded-lg shadow-xl transition-transform duration-500 ease-in-out">
										{card.text}
										<Icon
											icon="flowbite:arrow-right-outline"
											width="2rem"
											height="2rem"
											style={{ color: "white" }}
											className="ms-5 lg:block md:block hidden"
										/>
									</span>
								</Link>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}
